import { JobPostingDescriptionInterface } from "../types";
import moment from "@/date";
import { RFC_3339 } from "@/date";

const parseJobPostingTime = (time: string): Date =>
  moment(time, [moment.ISO_8601, RFC_3339]).toDate();

// The Pipedrive deal's own update time also moves on stage changes, activities and
// field edits, so the description notes are the only reliable "content updated" signal.
export const latestDescriptionUpdate = (
  descriptions: Array<JobPostingDescriptionInterface>
): string | undefined => {
  return descriptions.reduce<string | undefined>((latest, description) => {
    if (latest === undefined) {
      return description.updated_at;
    }

    return parseJobPostingTime(description.updated_at) > parseJobPostingTime(latest)
      ? description.updated_at
      : latest;
  }, undefined);
};
